exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#search-box[data-v-09a0e967]{position:relative}#search-box svg[data-v-09a0e967]{position:absolute;right:5px;top:10px}#search-result[data-v-09a0e967]{position:absolute;right:0;min-width:450px;background:#fff;padding:1rem;border:1px solid silver;max-height:calc(100vh - 100px);overflow:auto}", ""]);

// exports
